const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const getApiOrigin = () => {
  try {
    return new URL(API_BASE_URL).origin;
  } catch (error) {
    return "http://localhost:5000";
  }
};

export const resolveAssetUrl = (value) => {
  const raw = (value || "").trim();
  if (!raw) return "";

  // Already usable in the browser.
  if (
    raw.startsWith("http://") ||
    raw.startsWith("https://") ||
    raw.startsWith("data:image/") ||
    raw.startsWith("blob:")
  ) {
    return raw;
  }

  const origin = getApiOrigin();

  if (raw.startsWith("//")) {
    return `${window.location.protocol}${raw}`;
  }

  if (raw.startsWith("/")) {
    return `${origin}${raw}`;
  }

  return `${origin}/${raw}`;
};
